var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "提示文字" } },
        [
          _c("el-input", {
            attrs: {
              size: "small",
              placeholder: "请输入",
              maxlength: "50",
              "show-word-limit": "",
            },
            model: {
              value: _vm.value.placeholder,
              callback: function ($$v) {
                _vm.$set(_vm.value, "placeholder", $$v)
              },
              expression: "value.placeholder",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "radio-group-phone", attrs: { label: "类型" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.inputType,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "inputType", $$v)
                },
                expression: "value.inputType",
              },
            },
            [
              _c("el-radio", { attrs: { label: "phone" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("仅手机")]),
              ]),
              _c("el-radio", { attrs: { label: "tel" } }, [
                _c("span", { staticClass: "name-text" }, [_vm._v("仅固话")]),
              ]),
              _c("el-radio", { attrs: { label: "both" } }, [
                _c("span", { staticClass: "name-text" }, [
                  _vm._v("手机或固话"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }